import { createSlice } from '@reduxjs/toolkit';

import type { ProcessoArbitralListItem } from '@/features/secretaria-arbitral/types';
import type { AsyncStatus } from '@/shared/types/asyncState';

import { fetchArbitragensGlobais } from './actions';

interface ArbitragensGlobaisState {
  items: ProcessoArbitralListItem[];
  pagination: { page: number; limit: number; total: number };
  loading: boolean;
  error: string | null;
  status: AsyncStatus;
  /**
   * Guarda da resposta obsoleta: trocar busca ou filtro dispara um fetch novo antes do
   * anterior voltar, e sem isso a resposta antiga sobrescreveria a lista já filtrada.
   */
  requestIdAtual: string | null;
}

const initialState: ArbitragensGlobaisState = {
  items: [],
  pagination: { page: 1, limit: 20, total: 0 },
  loading: false,
  error: null,
  status: 'idle',
  requestIdAtual: null,
};

const arbitragensGlobaisSlice = createSlice({
  name: 'arbitragensGlobais',
  initialState,
  reducers: {
    resetArbitragensGlobais: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchArbitragensGlobais.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.status = 'loading';
        state.requestIdAtual = action.meta.requestId;
      })
      .addCase(fetchArbitragensGlobais.fulfilled, (state, action) => {
        if (state.requestIdAtual !== action.meta.requestId) return;
        state.loading = false;
        state.items = action.payload.items;
        state.pagination = {
          page: action.payload.page,
          limit: action.payload.limit,
          total: action.payload.total,
        };
        state.status = 'success';
      })
      .addCase(fetchArbitragensGlobais.rejected, (state, action) => {
        if (state.requestIdAtual !== action.meta.requestId) return;
        state.loading = false;
        state.error = action.payload ?? 'Erro desconhecido';
        state.status = 'error';
      });
  },
});

export const { resetArbitragensGlobais } = arbitragensGlobaisSlice.actions;
export const arbitragensGlobaisReducer = arbitragensGlobaisSlice.reducer;
